export default __webpack_public_path__ + "static/media/productPage1.714756a0.jpg";